// extracted by mini-css-extract-plugin
module.exports = {"main":"props_main__no5HV","group":"props_group__1ht1q","propLabel":"props_propLabel__1YDgr"};